// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"480f1247","239":"a4f34b58","453":"c12eb5f4","455":"392b8dd1"}[chunkId] + ".chunk.js";
};